import { render, staticRenderFns } from "./ExtensionColumn.vue?vue&type=template&id=2382e71e&scoped=true&"
import script from "./ExtensionColumn.vue?vue&type=script&lang=js&"
export * from "./ExtensionColumn.vue?vue&type=script&lang=js&"
import style0 from "./ExtensionColumn.vue?vue&type=style&index=0&id=2382e71e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2382e71e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VSkeletonLoader})
